import React from 'react';
import PropTypes from 'prop-types';
import style from './IncrementButton.module.css';

function IncrementButton({
  width,
  color,
  backgroundColor,
  stroke,
  handleClick,
  margin,
  buttonWidth,
  borderRadius,
  disabled,
}) {
  const padding = width / 6;
  return (
    <div
      className={style.button}
      style={{
        backgroundColor: disabled ? 'grey' : backgroundColor,
        margin,
        width: buttonWidth, 
        height: buttonWidth,
        borderRadius,
      }}
      onClick={() => {
        if (!disabled) handleClick();
        else return;
      }}
      type="button"
    >
      <svg className={style.svg} width={width} height={width}>
        <path
          d={`M${width / 2} ${padding} L${width / 2} ${
            width - padding
          } M${padding} ${width / 2} L${width - padding} ${width / 2}`}
          stroke={color}
          strokeWidth={stroke}
        />
      </svg>
    </div>
  );
}
IncrementButton.defaultProps = {
  borderRadius: '0',
  buttonWidth: '20px',
  disabled: false,
};
IncrementButton.propTypes = {
  borderRadius: PropTypes.string,
  buttonWidth: PropTypes.string,
  width: PropTypes.number.isRequired,
  margin: PropTypes.string,
  stroke: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  paddingPercent: PropTypes.number.isRequired,
  handleClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
export default IncrementButton;
